import * as userActions from '../user/actions';
import * as lawsThemesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const lawsThemesReducer = (state = initialState, action) => {
    switch (action.type) {
        case lawsThemesActions.SET_LAWS_THEMES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case lawsThemesActions.SET_LAWS_THEMES_ERROR:
            return {
                ...initialState,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case lawsThemesActions.SET_LAWS_ALL_THEMES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };
        case lawsThemesActions.ABORT_THEMES_REQUEST:
            return initialState;

        case lawsThemesActions.CLEAN_LAWS_THEMES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 23+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 27+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsThemes/reducer.js